module.exports = "/_next/static/images/bank-cimb-niaga-icon-6cf405a436c27f8da167ac8f9dd414df.svg";